import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import { FaCalendarAlt, FaClock, FaUserMd, FaStethoscope } from "react-icons/fa";
import { baseurImage } from "../../Baseurl";

export default function PortalAppointments({ patientId }) {
    const [appointments, setAppointments] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchAppointments = async () => {
            try {
                const response = await axiosInstance.post(`appointmentByPatientId/${patientId}`);
                if (response.data?.success) {
                    setAppointments(response.data.data);
                }
            } catch (error) {
                console.error("Error fetching appointments:", error);
            } finally {
                setLoading(false);
            }
        };

        if (patientId) {
            fetchAppointments();
        }
    }, [patientId]);

    const formatDate = (dateStr) => {
        if (!dateStr) return "N/A";
        return new Date(dateStr).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
        });
    };

    const formatTime = (start, end) => {
        if (!start || !end) return "N/A";
        const format12Hour = (time) => {
            const [hours, minutes] = time.split(":");
            let h = parseInt(hours);
            const m = minutes;
            const ampm = h >= 12 ? "PM" : "AM";
            h = h % 12 || 12;
            return `${h}:${m} ${ampm}`;
        };
        return `${format12Hour(start)} - ${format12Hour(end)}`;
    };

    if (loading) return <div className="p-4 text-center">Loading appointments...</div>;

    return (
        <div className="portal-module-container patientCommonCon">
            <h5 className="mb-4 h5Head">My Appointments</h5>

            {appointments.length === 0 ? (
                <div className="p-4 text-center bg-light rounded">
                    <p className="text-muted">No appointments found.</p>
                </div>
            ) : (
                <div className="d-flex flex-column gap-3">
                    {appointments.map((appt, index) => (
                        <div key={index} className="table-card card p-3">
                            <div className="d-flex flex-wrap  align-items-center gap-3 patientAppFlex">
                                <div className="d-flex align-items-start gap-3">
                                    <div className="myAppIconPat bg-primary bg-opacity-10 p-3 rounded-circle text-primary">
                                        <div className="d-flex">
                                            <FaCalendarAlt size={20} />
                                        </div>
                                    </div>
                                    <div>
                                        <div className="fw-bold fs-5 text-dark">
                                            {formatDate(appt.appointmentDate)}
                                        </div>

                                        <div className="d-flex align-items-center gap-2 text-muted mt-1">
                                            <FaClock size={14} />
                                            <span>{formatTime(appt.startTime, appt.endTime)}</span>
                                        </div>

                                    </div>
                                </div>

                                <div className="d-flex align-items-center gap-3">
                                    <div className="doctor-info-img">
                                        {appt.doctorImage ? (
                                            <img
                                                src={`${baseurImage}${appt.doctorImage}`}
                                                alt={appt.doctorName}
                                                className="rounded-circle shadow-sm"
                                                style={{ width: '45px', height: '45px', objectFit: 'cover', border: '1px solid #eee' }}
                                                onError={(e) => { e.target.src = "https://www.w3schools.com/howto/img_avatar.png" }}
                                            />
                                        ) : (
                                            <div className="bg-light p-2 rounded-circle text-secondary d-flex align-items-center justify-content-center shadow-sm" style={{ width: '45px', height: '45px', border: '1px solid #eee' }}>
                                                <FaUserMd size={22} />
                                            </div>
                                        )}
                                    </div>
                                    <div className="d-flex flex-column">
                                        <div className="fw-bold text-dark" style={{ fontSize: '1rem' }}>
                                            {appt.doctorName || "Doctor"}
                                        </div>
                                        <div className="text-muted small d-flex align-items-center gap-1">
                                            <FaStethoscope className="text-primary" size={12} />
                                            <span>{appt.doctorSpecialty || "General Checkup"}</span>
                                        </div>
                                    </div>
                                </div>

                                <div>
                                    <span className={`badge rounded-pill ${appt.status === 'Completed' ? 'bg-success' :
                                        appt.status === 'Scheduled' ? 'bg-primary' :
                                            'bg-secondary'
                                        }`}>
                                        {appt.status || "Scheduled"}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
